import { useEffect } from 'react'

export const useDocumentTitle = (title: string, dynamicTitle?: string) => {
  useEffect(() => {
    const baseTitle = 'Writely (ライトリー)'
    const displayTitle = dynamicTitle ? dynamicTitle : title
    document.title = displayTitle ? `${displayTitle} | ${baseTitle}` : baseTitle
  }, [title, dynamicTitle])
}
